import React from 'react';
import ReactGA from 'react-ga';
import { FormattedMessage } from 'react-intl';
import version from '../../../api/version';

const Footer = () => {
  const clickWebsite = () => {
    ReactGA.event({
      category: 'Quick links',
      action: 'Clicou em Website CARDS',
    });
  };

  const clickBlog = () => {
    ReactGA.event({
      category: 'Quick links',
      action: 'Clicou em Blog',
    });
  };

  return (
    <footer className="row">
      <div className="column">
        <div className="ui inverted segment">
          <div className="ui container equal width grid">
            <div className="column">
              <strong>Quick Links</strong>
              <div className="ui inverted list">
                <a
                  onClick={clickWebsite}
                  href="http://www.cards-expo.com.br"
                  className="item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FormattedMessage
                    id="futurecomWebsite"
                    description="CARDS website term"
                  />
                </a>
                <a
                  onClick={clickBlog}
                  href="http://cards-expo.com.br/blog/"
                  className="item"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Blog
                </a>
              </div>
            </div>
            <div className="right aligned column">
              <strong>
                <FormattedMessage
                  id="title"
                  description="App full title"
                />
              </strong>
              <br />
              <small>v{version}</small>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;



/** WEBPACK FOOTER **
 ** ./src/components/layout/footer/Footer.js
 **/